export const INVENTORY_TYPE = [
  { key: 'A Category', value: 'a', label: 'A Category' },
  { key: 'B Category', value: 'b', label: 'B Category' },
  { key: 'C Category', value: 'c', label: 'C Category' },
];

export const INVENTORY_HISTORY_METHOD = [
  { key: 'Replace', value: 'force_update', label: 'Replace' },
  { key: 'Add', value: 'increase', label: 'Add' },
  { key: 'Remove', value: 'decrease', label: 'Remove' },
  { key: 'Create', value: 'create', label: 'Create' },
  { key: 'Allocate', value: 'allocate', label: 'Allocate' },
  { key: 'Consume', value: 'consume', label: 'Consume' },
  { key: 'Deallocate', value: 'deallocate', label: 'Deallocate' },
];
